import { Injectable } from '@angular/core';
import { IIConType } from '@app/common-components/confirm-prompt.component';

export interface IConfirmPromptOptions {
  title?: string;
  secondaryMessage?: string;
  icon?: IIConType;
  approveButtonText?: string;
  cancelButtonText?: string;
  showCancelButton?: boolean;
  makeCancelPrimaryButton?: boolean;
  isNegativeCTA?: boolean;
  isLocaleSetting?: boolean;
  dashboardSettings?: any;
}

@Injectable({ providedIn: 'root' })
export class ConfirmPrompt {
  public component = null;

  public show(...args) {
    if (!this.component) return;
    return this.component.show(...args);
  }

  public hide() {
    if (!this.component) return;
    return this.component.hide();
  }

  public registerComponent(component) {
    this.component = component;
  }

  public isPromptHidden(): boolean {
    if (!this.component) return false;
    return this.component.isPromptHidden();
  }
}
